<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bb-page vaccinations-ticket-page"
  *ngIf="!contentReady"
>
  <div class="bb-page-shell vaccinations-ticket-shell">

    <!-- Header -->
    <header class="vaccinations-mobile-hero">
      <div class="vaccinations-hero-copy">
        <span class="bb-eyebrow">
          {{ 'Vaccination Records' | transloco }}
        </span>

        <h2>
          {{ 'Vaccination Records' | transloco }}
        </h2>

        <p>
          {{ allData.length || 0 }}
          {{ 'Vaccination History' | transloco }}
        </p>
      </div>

      <div class="vaccinations-hero-icon">
        <i class="fa-solid fa-syringe" aria-hidden="true"></i>
      </div>
    </header>

    <!-- Vaccination Form -->
    <section class="vaccinations-form-ticket">

      <div class="vaccinations-form-head">
        <div>
          <span class="bb-eyebrow">
            {{ editMode ? ('Edit' | transloco) : ('Submit' | transloco) }}
          </span>

          <h3>
            {{ 'Vaccination Records' | transloco }}
          </h3>
        </div>

        <button
          *ngIf="editMode"
          type="button"
          class="bb-btn bb-btn-secondary bb-btn-sm"
          (click)="resetForm()"
        >
          {{ 'Reset' | transloco }}
        </button>
      </div>

      <form [formGroup]="vaccinationForm" (ngSubmit)="saveVaccination()">

        <div class="vaccinations-form-grid">

          <div class="bb-field">
            <label class="bb-label" for="vaccine_name">
              {{ 'vaccine_name' | transloco }}
            </label>

            <input
              id="vaccine_name"
              type="text"
              class="bb-input"
              formControlName="vaccine_name"
              placeholder="{{ 'vaccine_name' | transloco }}"
              [ngClass]="{
                'is-invalid': vaccinationForm.get('vaccine_name')?.touched && vaccinationForm.get('vaccine_name')?.invalid,
                'is-valid': vaccinationForm.get('vaccine_name')?.touched && vaccinationForm.get('vaccine_name')?.valid
              }"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="manufacturer">
              {{ 'manufacturer' | transloco }}
            </label>

            <input
              id="manufacturer"
              type="text"
              class="bb-input"
              formControlName="manufacturer"
              placeholder="{{ 'manufacturer' | transloco }}"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="batch_number">
              {{ 'batch_number' | transloco }}
            </label>

            <input
              id="batch_number"
              type="text"
              class="bb-input"
              formControlName="batch_number"
              placeholder="{{ 'batch_number' | transloco }}"
            />
          </div>

          <!-- Vaccination Date -->
          <div class="bb-field">
            <label class="bb-label" for="vaccination_date">
              {{ 'vaccination_date' | transloco }}
            </label>

            <div class="bb-booking-calendar-field" [dir]="isAr ? 'rtl' : 'ltr'">
              <button
                type="button"
                class="bb-booking-calendar-trigger"
                id="vaccination_date"
                (click)="toggleDateCalendar('vaccination_date')"
                [ngClass]="{
                  'is-invalid': vaccinationForm.get('vaccination_date')?.touched && vaccinationForm.get('vaccination_date')?.invalid,
                  'is-valid': vaccinationForm.get('vaccination_date')?.touched && vaccinationForm.get('vaccination_date')?.valid
                }"
              >
                <span>
                  {{ getDateDisplay('vaccination_date', isAr ? 'اختار تاريخ التطعيم' : 'Select vaccination date') }}
                </span>
                <i class="fa-solid fa-calendar-days"></i>
              </button>

              @if(calendarState.vaccination_date.show) {
              <div class="bb-booking-calendar-panel">
                <div class="bb-booking-calendar-head">
                  <button type="button" (click)="previousDateCalendarMonth('vaccination_date')">
                    <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
                  </button>

                  <strong>{{ getDateCalendarTitle('vaccination_date') }}</strong>

                  <button type="button" (click)="nextDateCalendarMonth('vaccination_date')">
                    <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
                  </button>
                </div>

                <div class="bb-booking-calendar-weekdays">
                  @for(dayName of getDateCalendarWeekDays(); track dayName) {
                  <span>{{ dayName }}</span>
                  }
                </div>

                <div class="bb-booking-calendar-grid">
                  @for(calendarDay of getDateCalendarDays('vaccination_date'); track calendarDay.date.getTime()) {
                  <button
                    type="button"
                    class="bb-booking-calendar-day"
                    [class.other-month]="!calendarDay.isCurrentMonth"
                    [class.today]="calendarDay.isToday"
                    [class.selected]="calendarDay.isSelected"
                    [disabled]="calendarDay.isDisabled"
                    (click)="selectDateCalendarDate('vaccination_date', calendarDay.date)"
                  >
                    {{ calendarDay.dayNumber }}
                  </button>
                  }
                </div>
              </div>
              }
            </div>

            <input type="hidden" formControlName="vaccination_date" />
          </div>

          <!-- Next Due Date -->
          <div class="bb-field">
            <label class="bb-label" for="next_due_date">
              {{ 'next_due_date' | transloco }}
            </label>

            <div class="bb-booking-calendar-field" [dir]="isAr ? 'rtl' : 'ltr'">
              <button
                type="button"
                class="bb-booking-calendar-trigger"
                id="next_due_date"
                (click)="toggleDateCalendar('next_due_date')"
                [ngClass]="{
                  'is-valid': vaccinationForm.get('next_due_date')?.value
                }"
              >
                <span>
                  {{ getDateDisplay('next_due_date', isAr ? 'اختار تاريخ الجرعة القادمة' : 'Select next due date') }}
                </span>
                <i class="fa-solid fa-calendar-days"></i>
              </button>

              @if(calendarState.next_due_date.show) {
              <div class="bb-booking-calendar-panel">
                <div class="bb-booking-calendar-head">
                  <button type="button" (click)="previousDateCalendarMonth('next_due_date')">
                    <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
                  </button>

                  <strong>{{ getDateCalendarTitle('next_due_date') }}</strong>

                  <button type="button" (click)="nextDateCalendarMonth('next_due_date')">
                    <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
                  </button>
                </div>

                <div class="bb-booking-calendar-weekdays">
                  @for(dayName of getDateCalendarWeekDays(); track dayName) {
                  <span>{{ dayName }}</span>
                  }
                </div>

                <div class="bb-booking-calendar-grid">
                  @for(calendarDay of getDateCalendarDays('next_due_date'); track calendarDay.date.getTime()) {
                  <button
                    type="button"
                    class="bb-booking-calendar-day"
                    [class.other-month]="!calendarDay.isCurrentMonth"
                    [class.today]="calendarDay.isToday"
                    [class.selected]="calendarDay.isSelected"
                    [disabled]="calendarDay.isDisabled"
                    (click)="selectDateCalendarDate('next_due_date', calendarDay.date)"
                  >
                    {{ calendarDay.dayNumber }}
                  </button>
                  }
                </div>
              </div>
              }
            </div>

            <input type="hidden" formControlName="next_due_date" />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="authorized_vet">
              {{ 'authorized_vet' | transloco }}
            </label>

            <input
              id="authorized_vet"
              type="text"
              class="bb-input"
              formControlName="authorized_vet"
              placeholder="{{ 'authorized_vet' | transloco }}"
            />
          </div>

          <div class="bb-field vaccinations-field-full">
            <label class="bb-label" for="notes">
              {{ 'note' | transloco }}
            </label>

            <textarea
              id="notes"
              rows="3"
              class="bb-input vaccinations-textarea"
              formControlName="notes"
              placeholder="{{ 'note' | transloco }}"
            ></textarea>
          </div>

        </div>

        <div class="vaccinations-form-actions">
          <button
            class="bb-btn bb-btn-primary"
            type="submit"
            [disabled]="vaccinationForm.invalid"
          >
            <i class="fa-solid fa-check" aria-hidden="true"></i>

            {{ editMode ? ('Update' | transloco) : ('Submit' | transloco) }}
          </button>

          <button
            class="bb-btn bb-btn-secondary"
            type="button"
            (click)="resetForm()"
          >
            {{ 'Reset' | transloco }}
          </button>
        </div>

      </form>
    </section>

    <!-- History Header -->
    <section class="vaccinations-history-head">
      <div>
        <span>
          {{ 'Vaccination History' | transloco }}
        </span>

        <h3>
          {{ 'Vaccination History' | transloco }}
        </h3>
      </div>

      <strong>
        {{ visibleData.length }} / {{ allData.length }}
      </strong>
    </section>

    <!-- No Data -->
    <div *ngIf="noData" class="bb-empty-state bb-text-center">
      <app-nodata></app-nodata>
    </div>

    <!-- Cards -->
    <section class="vaccinations-ticket-list" *ngIf="!noData">

      <article
        class="vaccination-ticket"
        *ngFor="let element of visibleData; trackBy: trackByVaccinationId"
        [class.is-upcoming]="isUpcoming(element.next_due_date)"
        [class.is-overdue]="isOverdue(element.next_due_date)"
      >

        <!-- Top -->
        <div class="vaccination-ticket-top">

          <div class="vaccination-main-info">
            <div class="vaccination-avatar">
              <i class="fa-solid fa-syringe" aria-hidden="true"></i>
            </div>

            <div class="vaccination-copy">
              <span>
                {{ 'vaccine_name' | transloco }}
              </span>

              <h3>
                {{ element.vaccine_name || '—' }}
              </h3>

              <p>
                <i class="fa-solid fa-building" aria-hidden="true"></i>
                {{ element.manufacturer || '—' }}
              </p>
            </div>
          </div>

          <div class="vaccination-batch-badge">
            <span>
              {{ 'batch_number' | transloco }}
            </span>

            <strong>
              {{ element.batch_number || '—' }}
            </strong>
          </div>

        </div>

        <!-- Details -->
        <div class="vaccination-ticket-details">

          <div class="vaccination-detail-chip">
            <i class="fa-solid fa-calendar-check" aria-hidden="true"></i>

            <span>
              {{ 'vaccination_date' | transloco }}
            </span>

            <strong>
              {{ element.vaccination_date ? (element.vaccination_date | date: 'yyyy-MM-dd') : '—' }}
            </strong>
          </div>

          <div class="vaccination-detail-chip">
            <i class="fa-solid fa-clock" aria-hidden="true"></i>

            <span>
              {{ 'next_due_date' | transloco }}
            </span>

            <strong
              [class.date-upcoming]="isUpcoming(element.next_due_date)"
              [class.date-overdue]="isOverdue(element.next_due_date)"
            >
              {{ element.next_due_date ? (element.next_due_date | date: 'yyyy-MM-dd') : '—' }}
            </strong>
          </div>

          <div class="vaccination-detail-chip vaccination-detail-wide">
            <i class="fa-solid fa-user-doctor" aria-hidden="true"></i>

            <span>
              {{ 'authorized_vet' | transloco }}
            </span>

            <strong>
              {{ element.authorized_vet || '—' }}
            </strong>
          </div>

        </div>

        <!-- Notes -->
        <div class="vaccination-notes-ticket" *ngIf="element.notes">
          <span>
            <i class="fa-solid fa-note-sticky" aria-hidden="true"></i>
            {{ 'note' | transloco }}
          </span>

          <p>
            {{ element.notes }}
          </p>
        </div>

        <!-- Actions -->
        <div class="vaccination-ticket-actions">

          <button
            type="button"
            class="vaccination-action-btn vaccination-action-edit"
            (click)="editVaccination(element)"
          >
            <i class="fa-solid fa-pen" aria-hidden="true"></i>
            <span>{{ 'Edit' | transloco }}</span>
          </button>

          <button
            type="button"
            class="vaccination-action-btn vaccination-action-danger"
            (click)="deleteVaccination(element.id)"
          >
            <i class="fa-solid fa-trash" aria-hidden="true"></i>
            <span>{{ 'Delete' | transloco }}</span>
          </button>

        </div>

      </article>

    </section>

    <!-- Loading More -->
    <div class="vaccinations-mobile-loader" *ngIf="isLoadingMore">
      <span aria-hidden="true"></span>
      <strong>{{ 'Loading' | transloco }}...</strong>
    </div>

    <!-- End State -->
    <div
      class="vaccinations-end-state"
      *ngIf="!noData && !hasMoreData && allData.length > pageSize"
    >
      {{ 'No more data' | transloco }}
    </div>

  </div>
</section>